export type Portal = "reception" | "ca";

export interface PortalAuthConfig {
  tokenKey: string;
  profileKey: string;
  loginUrl: string;
  profileUrl: string;
  forgetOtpUrl: string;
  forgetOtpVerifyUrl: string;
  setPasswordUrl: string;
  contactEnquiryUrl?: string;
  afterLoginPath: string;
  resetPasswordPath: string;
  /** CA first-login forced password change (after `passwordResetRequired` login). */
  changePasswordPath?: string;
}

const receptionAuthConfig: PortalAuthConfig = {
  tokenKey: "token",
  profileKey: "profile",
  loginUrl: "/api/v1/clinics/receptionist/login",
  profileUrl: "/api/v1/clinics/receptionist/profile",
  forgetOtpUrl: "/api/v1/clinics/receptionist/forget/otp",
  forgetOtpVerifyUrl: "/api/v1/clinics/receptionist/forget/otp/verify",
  setPasswordUrl: "/api/v1/clinics/receptionist/password",
  afterLoginPath: "/today-appointment",
  resetPasswordPath: "/reset-password",
};

const caAuthConfig: PortalAuthConfig = {
  tokenKey: "ca_token",
  profileKey: "ca_profile",
  loginUrl: "/api/v1/clinics/ca/login",
  profileUrl: "/api/v1/clinics/ca/profile",
  forgetOtpUrl: "/api/v1/clinics/ca/forget/otp",
  forgetOtpVerifyUrl: "/api/v1/clinics/ca/forget/otp/verify",
  setPasswordUrl: "/api/v1/clinics/ca/password",
  contactEnquiryUrl: "/api/v1/clinics/ca/contact-us",
  afterLoginPath: "/form-25",
  resetPasswordPath: "/reset-password",
  changePasswordPath: "/change-password",
};

export function getPortal(): Portal {
  return process.env.REACT_APP_PORTAL === "ca" ? "ca" : "reception";
}

export function getPortalAuthConfig(): PortalAuthConfig {
  return getPortal() === "ca" ? caAuthConfig : receptionAuthConfig;
}

/** Router basename; matches PUBLIC_URL for subpath deploys (e.g. /ca). */
export function getRouterBasename(): string {
  const publicUrl = process.env.PUBLIC_URL || "/";
  if (publicUrl.startsWith("http")) {
    try {
      return new URL(publicUrl).pathname.replace(/\/$/, "") || "/";
    } catch {
      return "/";
    }
  }
  const path = publicUrl.replace(/\/$/, "");
  return path || "/";
}
